// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import components
import ItemsList from "../../components/ItemsList";
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetBrands, DeleteBrand
} from "../../redux/actions";
import {generateImageMediaUrl} from "../../utils/generateMemberMediaUrl";


class Brand extends Component {
    componentDidMount() {
        this.props.GetBrands();
    }

    render() {
        let {brands, requestLoading} = this.props;
        let itemListHeaderInfo = {
            generalInfo: ["Նկար", "Անվանում", ],
            largeItems: [1],
            status: true,
            actions: ["edit", "delete"],
        };
        let itemListInfo = brands.itemsList?.map((brand) => {
            const {id, title, mediaMain, isHidden} = brand;
            return {
                id,
                values: [
                    {
                        title: <img src={generateImageMediaUrl(mediaMain?.path)}/>
                    },
                    title ?? '-',
                ],
                status: !isHidden,
                deleteCb: deleteItem.bind(this, this.props.DeleteBrand, 'բրենդը', id)
            }
        });
        return <PageWrapper pageTitle={'Բրենդ'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/brand/add"}/>
            <ItemsList itemListHeaderInfo={itemListHeaderInfo}
                       itemListInfo={itemListInfo}
                       loading={requestLoading}
                       editLink={"/brand/edit"}/>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBrands,
    DeleteBrand,
};

export default connect(mapStateToProps, mapDispatchToProps)(Brand);
